export default __webpack_public_path__ + "static/media/male_center_chest.d9f8a789.png";